import { Injectable } from '@angular/core';
import { ProductViewType } from 'gung-standard';
import { JeevesBaseViewConfigService } from 'gung-standard-jeeves';

@Injectable({
  providedIn: 'root'
})
export class SjoborgBaseViewConfigService extends JeevesBaseViewConfigService {
  productViewType: ProductViewType = ProductViewType.assortmentTreeView;
}
